import Service from '@/service/building'
export default {
    data () {
        return {
            visit_building_article: null
        }
    },
    methods: {
        getVisitBuildingArticle () {
            const { building_id } = this.$route.query
            Service.getFeeds(building_id, '踩盘看点').then((data) => {
                if (data.items && data.items.length) {
                    this.visit_building_article = data.items[0]
                } else {
                    this.visit_building_article = null
                }
            })
        }
    }
}